// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes-area {
  height: 160px;
}

.body-fixture {
  padding: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/fixture-details/fixture-body-details/fixture-body-details.component.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;AADJ;;AAIA;EACE,aAAA;EACA,wCAAA;EACA,uBAAA;AADF","sourcesContent":["\n\n.notes-area {\n    height: 160px;\n}\n\n.body-fixture {\n  padding: 1rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
